var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('v-container',{staticClass:"w--max--800",attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"column":"","text-xs-center":""}},[_c('v-flex',{staticClass:"mt-5",attrs:{"tag":"h2"}},[_vm._v("\n        Choose a plan to find your NannyGranny\n      ")]),_vm._v(" "),_c('v-flex',[_c('AppplanReview')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7041146c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/home/components/app-home-plan.vue
// module id = null
// module chunks = 